module.exports = __webpack_public_path__ + "media/images/lp_seiho/sp_main-61ab8ddfcfa1bf8888b717574aeda62c.png";